// @ts-ignore
import './index.module.scss'
// eslint-disable-next-line import/no-unresolved
import 'virtual:svg-icons-register'

import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import { AuthProvider } from './Providers/AuthProvider'

/**
 * The Core auth cookie lives on .islamstudies.nl. On a koranvoorkids.nl host it is a
 * third-party cookie that Safari and others block, so logging in there (password, or a
 * session from the login link) would silently not stick. Serve the app same-site instead.
 */
const SAME_SITE_ORIGIN = 'https://koranvoorkids.islamstudies.nl'
const { hostname, pathname, search, hash } = window.location
if (hostname === 'koranvoorkids.nl' || hostname.endsWith('.koranvoorkids.nl'))
  window.location.replace(`${SAME_SITE_ORIGIN}${pathname}${search}${hash}`)

// @ts-ignore
ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <App />
  </AuthProvider>
)
